<template>
  <div class="container-fluid mt-4">

    <FolderItem
      v-for="item in items"
      :key="item.id"
      :item="item"
      :expanded="expanded"
      @toggle="toggle"
    />
  </div>
</template>

<script>
import FolderItem from "./FolderItem.vue";

export default {
  name: "FileList",

  components: { FolderItem },

  data() {
    return {
      expanded: {},
      items: []
    };
  },

  mounted() {
    this.fetchDataBank();
  },

  methods: {
    toggle(id) {
      this.expanded[id] = !this.expanded[id];
    },

    fetchDataBank() {
      import("@/components/json/jsonQuyetDinh.json").then((module) => {
        const data = JSON.parse(JSON.stringify(module.default));
        this.items = data;
      });
    }
  },
};
</script>
